import React from 'react';
import MenuInfo from './MenuInfo';

export default function InfoButtonContainer(props) {
    return (
        <div className="col-start-9 col-end-10 flex items-center justify-center">
            <MenuInfo index={props.index} />
        </div>
    );
}
